import router from '../services/router_service';
import postController from '../controllers/post_controller';

router.on('route:post', postController);
